<template>
  <v-dialog
    v-model="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="cancel"
  >
    <v-card>
      <v-container class="px-10 pt-8">
        <p class="subtitle-1 font-weight-bold mb-0">Link Unit</p>
        <v-form>
          <v-row>
            <v-col class="py-0" cols="12" sm="12" md="12">
              <v-select
                v-model="bedId"
                :items="
                  unitsToShow.filter((t) =>
                    t.text.toLowerCase().includes(searchUnit.toLowerCase())
                  )
                "
                label="Unit"
                prepend-inner-icon="mdi-bed-empty"
              >
                <template v-slot:prepend-item>
                  <v-list-item ripple>
                    <v-list-item-content>
                      <v-text-field
                        v-model="searchUnit"
                        outlined
                        dense
                        hide-details
                        placeholder="Search Unit"
                      ></v-text-field>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </template>
              </v-select>
            </v-col>
          </v-row>
        </v-form>
        <v-card-actions class="pt-6">
          <v-spacer></v-spacer>
          <v-btn
            color="primary darken-1"
            :disabled="!Number.isInteger(bedId)"
            text
            @click="finish"
          >
            Finish
          </v-btn>
          <v-btn color="grey darken-1" text @click="cancel">Cancel</v-btn>
        </v-card-actions>
      </v-container>
    </v-card>
    <v-overlay :value="loading" absolute>
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    occupiedUnits: [],
    vacantUnits: [],
    bedId: -1,
    vacantBedId: -1,
    dialog: false,
    resolve: null,
    reject: null,
    options: {
      color: 'primary',
      width: 500,
      zIndex: 200
    },
    date: new Date().toISOString().substr(0, 10),
    loading: true,
    unitsToShow: [],
    searchUnit: ''
  }),
  computed: {
    aliases() {
      return this.$store.getters['users/getAliases']
    },
    units() {
      return this.$store.getters['units/getUnitsFlat']
    }
  },
  watch: {
    date() {
      this.moveInDate = this.formatDate(this.date)
    }
  },
  methods: {
    async open(params) {
      this.vacantBedId = params.bedId

      this.dialog = true
      this.loading = false
      this.occupiedUnits = this.units
        .filter((u) => u.status === 'occupied' && u.bedId != params.bedId)
        .map((unit) => {
          return {
            text: `${unit.bedName} - ${this.getTenantName(
              unit.tenant_details
            )}`,
            value: unit.bedId
          }
        })
      this.vacantUnits = this.units
        .filter((u) => u.status === 'vacant' && u.bedId != params.bedId)
        .map((unit) => {
          return {
            text: `${unit.bedName} - (empty)`,
            value: unit.bedId
          }
        })
      this.unitsToShow = [...this.occupiedUnits, ...this.vacantUnits]
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    cancel() {
      // this.resolve(false)
      this.dialog = false
    },
    async finish() {
      this.loading = true
      const unitName = this.unitsToShow.find((u) => u.value === this.bedId).text

      if (
        await this.$root.$confirm({
          title: 'Link Unit',
          message: `Would you like to link this unit to ${unitName}?`
        })
      ) {
        await this.$store.dispatch('units/linkUnitsAction', {
          vacantBedId: this.vacantBedId,
          chosenBedId: this.bedId
        })
        this.$root
          .$confirm({
            title: 'Link Unit',
            message: `The unit has been linked`,
            reconfirmOnly: true,
            confirmText: 'OK'
          })
          .then(async () => {
            this.loading = false
            this.dialog = false
            this.resolve(true)
          })
        // window.location.reload()
      }
    },
    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${month}/${day}/${year}`
    },
    parseDate(date) {
      if (!date) return null

      const [month, day, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    getTenantName(tenant) {
      if (!tenant) return ''
      const alias = this.getAlias(tenant.userId)
      if (alias) {
        return alias
      }
      let displayName = ''
      if (tenant.firstName) {
        displayName += tenant.firstName + ' '
        if (tenant.lastName) {
          displayName += tenant.lastName + ' '
        }
      } else {
        return (displayName = tenant.username)
      }

      return displayName
    },
    getAlias(tenantId) {
      const alias = this.aliases.find((a) => a.tenantId === tenantId)

      return alias && alias.name
    }
  }
}
</script>
